export default "__VITE_ASSET__BP$o9IDB__"